import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { offerTypeFromJsonQuery } from 'shared/common/packages/JsonQuery';
import { selectJsonQuery } from 'shared/map-search/selectors/results';

import { trackClickBanner, trackShowBanner } from './tracking';
import { DesktopBanner } from '../../components/CPDBanner';
import { selectIsOpen } from '../../selectors/searchResults';
import { IApplicationState } from '../../types/redux';

export interface ICPDBannerContainerProps {
  open: boolean;
  onClose(): void;
}

export const CPDBannerContainer: React.FC<ICPDBannerContainerProps> = ({ open, onClose }) => {
  const deviceType = useDeviceType();
  const isSearchResultsOpen = useSelector(selectIsOpen);
  const jsonQuery = useSelector(selectJsonQuery);
  const landingUrl = useSelector((state: IApplicationState) => state.cpd?.landingUrl);
  const offerType = offerTypeFromJsonQuery(jsonQuery);

  const isBannerVisible = open && deviceType === 'desktop';

  React.useEffect(() => {
    if (isBannerVisible) {
      trackShowBanner(offerType);
    }
  }, [isBannerVisible, offerType]);

  React.useEffect(() => {
    if (open && isSearchResultsOpen) {
      onClose();
    }
  }, [open, isSearchResultsOpen, onClose]);

  if (isBannerVisible) {
    return (
      <DesktopBanner
        onClick={() => trackClickBanner(offerType)}
        onClose={onClose}
        isSearchResultsOpen={isSearchResultsOpen}
        href={landingUrl}
      />
    );
  }

  return null;
};

CPDBannerContainer.displayName = 'CPDBannerContainer';
